import React from "react";
import useStyles from "./styles";
import FindInPageIcon from "@material-ui/icons/FindInPage";

const  SearchingRecord = () => {
  const classes = useStyles();
  return (
    <div className={classes.notFoundContainer}>
      <div className={classes.textboxClass}>
        <FindInPageIcon />
        <h2>Record Searching</h2>
        <p>Please wait, while we load your data.</p> 
      </div>
    </div>
  );
}


export default SearchingRecord;